import axios from 'axios';
import { policyUrl } from './precision';
import config from './config';

// instance without interceptor saga events
// as the events are updating common store
const instance = axios.create(config);

const scheduleUrl = `${policyUrl}/schedule`;

function getSchedule(http = instance) {
  return http.get(scheduleUrl);
}

function updateSchedule(reqBody, options = {}, http = instance) {
  return http.post(scheduleUrl, reqBody, options);
}

function deleteSchedule(scheduleId, options = {}, http = instance) {
  return http.delete(`${scheduleUrl}/${scheduleId}`, options);
}

function getEmails(http = instance) {
  return http.get(`${scheduleUrl}/emails`);
}

export {
  getSchedule,
  updateSchedule,
  deleteSchedule,
  getEmails,
};
